/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IMfrmProductRecommendationCarouselViewProps } from './mfrm-product-recommendation-carousel';
import Carousel from 'mfcl/Carousel';

export default (props: IMfrmProductRecommendationCarouselViewProps) => {
    const { carouselHeading, carouselItems, isMobile, currentPageName } = props;
    if (!carouselItems) {
        props.context.telemetry.error('Product Recommendations is empty, module wont render.');
        return null;
    }

    return (
        carouselItems ? <div className='product-recommendations-container'>
            <div className='product-recommendations-container__header'>
                <h2>{carouselHeading}</h2>
            </div>
            <div className={`mfcl-carousel__container`} data-testid={`${currentPageName}-carouselImage`}>
                {isMobile ? (
                    <div className='mfcl-carousel__mobile'>
                        <Carousel
                            itemsToShow={2}
                            ariaLabel='one'
                            hideIndicators
                            hideControls
                            controlStyle='legacy'
                            controlClass="mfcl-carousel__button"
                            layoutGap={15}
                            infinite
                            disableEndButtons={isMobile}
                            variableWidth={isMobile}
                        >
                            {carouselItems}
                        </Carousel>
                    </div>
                ) : (
                    <Carousel
                        itemsToShow={4}
                        ariaLabel='one'
                        hideIndicators
                        hideControls
                        controlStyle='legacy'
                        controlClass="mfcl-carousel__button"
                        disableEndButtons={true}
                        infinite
                        layoutGap={6}
                        responsive={[
                            {
                                breakpoint: 768,
                                itemsToShow: 3,
                                layoutGap: 4
                            }
                        ]} >
                        {carouselItems}
                    </Carousel>
                )}
            </div>
        </div>
            : <></>
    );
};
